import { useState } from 'react'
import { motion } from 'framer-motion'
import { Menu, X, Brain } from 'lucide-react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  const [open, setOpen] = useState(false)

  const links = [
    { name: 'Accueil', href: '#hero' },
    { name: 'À Propos', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Formations', href: '#formations' },
    { name: 'Vidéos', href: '#videos' },
    { name: 'Jeu Mental', href: '#game' }
  ]

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          <motion.div 
            className="flex items-center gap-2"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
             <Link to="/" className="flex items-center gap-3 group">
            {/* Logo image */}
            <img 
              src="images/logo.png"
              alt="Logo"
              className="h-12 w-auto group-hover:scale-105 transition-transform duration-300"
            />
             
          </Link>
            <span className="text-2xl font-bold text-gradient">GENIUS CLUB</span>
           
          </motion.div>

          <div className="hidden md:flex items-center gap-8">
            {links.map((link, i) => (
              <motion.a
                key={link.name}
                href={link.href}
                className="text-gray-700 hover:text-primary transition-colors duration-300 font-medium"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                {link.name}
              </motion.a>
            ))}
            <motion.button
              className="btn-primary"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
               onClick={() => {
    const message = "Bonjour GENIUS CLUB !%0A%0AJe suis intéressé(e) par vos services et je souhaiterais obtenir plus d'informations.%0A%0APouvez-vous me contacter ?%0A%0A_Ce message a été envoyé via le site web_";
    const whatsappUrl = `https://wa.me/212673737468?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }}
            >
              Contactez-nous
            </motion.button>
          </div>

          <button className="md:hidden" onClick={() => setOpen(!open)}>
            {open ? <X className="w-6 h-6 text-primary" /> : <Menu className="w-6 h-6 text-primary" />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          className="md:hidden bg-white border-t"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
        >
          <div className="container-custom py-4 flex flex-col gap-4">
            {links.map(link => (
              <a
                key={link.name}
                href={link.href}
                className="text-gray-700 hover:text-primary transition-colors duration-300 font-medium"
                onClick={() => setOpen(false)}
              >
                {link.name}
              </a>
            ))}
<button 
  onClick={() => {
    const message = "Bonjour GENIUS CLUB !%0A%0AJe suis intéressé(e) par vos services et je souhaiterais obtenir plus d'informations.%0A%0APouvez-vous me contacter ?%0A%0A_Ce message a été envoyé via le site web_";
    const whatsappUrl = `https://wa.me/212673737468?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }}
  className="btn-primary w-full"
>
  Contactez-nous
</button>          </div>
        </motion.div>
      )}
    </nav>
  )
}

export default Navbar